// extracted by mini-css-extract-plugin
export var active = "_cg-7";
export var blink = "_cg-8";
export var dropDownSelector = "_cg-4";
export var dropDownWrapper = "_cg-3";
export var fakeCursor = "_cg-6";
export var fontSizeButton = "_cg-9";
export var formQuillEditor = "_cg-0";
export var pressed = "_cg-a";
export var qlBlank = "_cg-1";
export var textFormattingToolbar = "_cg-2";
export var textToolbarOption = "_cg-5";